// extracted by mini-css-extract-plugin
export default {"projectLink":"ProjectV2-module__projectLink__GIBTuCb"};